import { Box } from "@mui/material";
import { Fragment } from "react";
import { selectOrderSummary } from "slices/transactionSlice";

import { useAppSelector } from "hooks/utilsHooks/storeHooks";
import { DishItemDisplayType } from "types/mainTypes";

import DishTypeItem from "../../dishTypeItem";
import { StyledDishTypeList } from "./StyledDishTypeList";
import { OrderDishDivider } from "./orderStepDrawerStyles";

export const OrderDishesList = ({ smallOrderLimit }: { smallOrderLimit: number }) => {
	const orderSummary = useAppSelector(selectOrderSummary);

	if (!orderSummary) {
		return null;
	}

	const { discountedDishTypes, fullPricedDishCounts, discountedDishCounts, orderDishTypesCount } =
		orderSummary;

	const isLargeOrder = orderDishTypesCount > smallOrderLimit;
	const hasMoreThanOneDishType = orderDishTypesCount > 1;

	return (
		<StyledDishTypeList
			sx={{ height: "750px", paddingBottom: "30px" }}
			isLargeOrder={isLargeOrder}
			data-testid="overview-dish-list"
		>
			{discountedDishTypes && discountedDishTypes.length > 0 && (
				<>
					{discountedDishTypes.map((dishType) => (
						<Fragment key={`orderDiscountedDishTypeItem_${dishType.id}`}>
							<Box data-testid="overview-dish-row">
								<DishTypeItem
									dishType={dishType}
									type={DishItemDisplayType.ORDER}
									key={`orderStep5_item_${dishType.id}`}
									pieces={discountedDishCounts?.[dishType.id] || 0}
								/>
							</Box>
							{discountedDishTypes.length > 0 && hasMoreThanOneDishType && (
								<OrderDishDivider />
							)}
						</Fragment>
					))}
				</>
			)}
			{orderSummary.orderDishTypes.map((dishType, index) => (
				<Fragment key={`orderDishTypeItem_${dishType.id}`}>
					<Box data-testid="overview-dish-row">
						<DishTypeItem
							dishType={dishType}
							type={DishItemDisplayType.ORDER}
							key={`orderStep5_item_${dishType.id}`}
							pieces={fullPricedDishCounts?.[dishType.id] || 0}
						/>
					</Box>
					{hasMoreThanOneDishType && index !== orderDishTypesCount - 1 && (
						<OrderDishDivider />
					)}
				</Fragment>
			))}
		</StyledDishTypeList>
	);
};
